import { render, staticRenderFns } from "./CardLegendItem.vue?vue&type=template&id=b6aa2b92&"
import script from "./CardLegendItem.vue?vue&type=script&lang=ts&"
export * from "./CardLegendItem.vue?vue&type=script&lang=ts&"
import style0 from "./CardLegendItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
